import { useState } from 'react'
import { Create_Book } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { useBooks } from '@hooks/useBooks'

const useCreateBook = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const { mutate } = useBooks()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Create_Book,
      successMessage ? successMessage : 'Bok skapad.',
      errorMessage ? errorMessage : 'Nåt gick fel när boken skulle skapas.',
      async () => {
        await mutate() // refetch books listing
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useCreateBook }
